import { useRef, useState } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from '@mui/material';
import Draggable from 'react-draggable';
import produce from 'immer';

import { updateAssignmentTimeWindow } from '@/repositories/HttpRepository';
import { assignmentsState, updateTWAssignmentsState, updateTimeWindowState } from './States';
import { useRecoilValue, useRecoilState, useResetRecoilState } from 'recoil';

function PaperComponent(props) {
  const nodeRef = useRef(null);
  return (
    <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default function UpdateTimeWindow() {
  const [minutes, setMinutes] = useState(0);
  const updateTimeWindowInfo = useRecoilValue(updateTimeWindowState);
  const resetUpdateTimeWindowInfo = useResetRecoilState(updateTimeWindowState);
  const [assignments, updateData] = useRecoilState(updateTWAssignmentsState);
  const { show, assignmentIds } = updateTimeWindowInfo;

  const handleClose = () => {
    resetUpdateTimeWindowInfo();
  };

  const onUpdate = () => {
    const promises = assignmentIds.map((assignmentId) =>
      updateAssignmentTimeWindow(assignmentId, minutes)
    );

    Promise.all(promises).then((responses) => {
      const allSuccessful = responses.every((resp) => resp.ok);
      if (allSuccessful) {
        updateData(minutes);
      }
    });
  };

  const updateMinutes = (e) => {
    setMinutes(parseInt(e.target.value, 10));
  };

  return (
    <Dialog open={show} onClose={handleClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Update Time Window
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Update time window for following assignments: {assignments.filter((a) => a != null).map((a) => a.label).join(',')}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="Minutes"
          label="Minutes"
          type="number"
          value={minutes}
          onChange={updateMinutes}
          fullWidth
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button disableElevation autoFocus onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button disableElevation variant="contained" color="primary" onClick={onUpdate} disabled={!minutes || minutes <= 0}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
